/* @ngInject */
function WorkflowController ($scope, $rootScope, $state, $location, $controller, $timeout, BoardsService, ViewOptionService) {
  angular.extend(this, $controller('SidebarSecondLevelMenuController', { $scope: $scope }))

  $rootScope.isSecondLevelSidebarExpanded = false
  $scope.flags = {
    loadingWorkflow: false
  }

  const api = {
    _handleSidebar,
    _doHandlePaths
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._handleSidebar($state.current.name)
  }

  const deregisterStateChangeSuccess = $scope.$on('$stateChangeSuccess', (event, state) => {
    api._handleSidebar(state.name)

    if (state.name === 'workflow') {
      api._doHandlePaths()
    }
  })

  $scope.$on('$destroy', () => {
    deregisterStateChangeSuccess()
  })

  function _handleSidebar (state) {
    const hasSidebar = [
      'workflow.kanban',
      'workflow.list',
      'workflow.calendar'
    ]
    $scope.flags.showSecondLevelSidebar = hasSidebar.includes(state)
  }

  function _doHandlePaths () {
    $scope.flags.loadingWorkflow = true
    $rootScope.getUser().then(user => {
      $scope.flags.loadingWorkflow = false
      if ($rootScope.isUser(user)) {
        $timeout(() => {
          $state.go('workflow.requests')
        })
      } else {
        $state.go('workflow.home')
      }
    })
  }
}

export { WorkflowController }
